import { TaskAttentionIcon } from '@/src/renderer/components/icons'
import './TaskAttentionBadge.scss'
import type { TaskAttentionBadgeProps } from './TaskAttentionBadge.types'

export function TaskAttentionBadge({ level }: TaskAttentionBadgeProps) {
  return (
    <span className="task-attention-badge">
      <TaskAttentionIcon size={16} level={level} />
    </span>
  )
}
